module.exports = __webpack_public_path__ + "static/media/header_logo_window_simulator@2x.e7bb731e.png";